import { render, staticRenderFns } from "./ThePageHeader.vue?vue&type=template&id=48158c20&scoped=true"
import script from "./ThePageHeader.vue?vue&type=script&lang=js"
export * from "./ThePageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48158c20",
  null
  
)

export default component.exports